module.exports = "<h1 mat-dialog-title>Barzahlung</h1>\r\n<mat-dialog-content>\r\n    <div>\r\n        Vielen Dank für Ihre Bestellung!<br />\r\n        Bitte bringen Sie bei der Abholung das Geld Bar möglichst genau mit.\r\n    </div>\r\n</mat-dialog-content>\r\n<mat-dialog-actions>\r\n    <button mat-raised-button mat-dialog-close color=\"primary\">{{'LC_CLOSE'|translate}}\r\n    </button>\r\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/checkout/dialog/pickup/pickup.component.html
// module id = ./src/app/components/checkout/dialog/pickup/pickup.component.html
// module chunks = main